module.exports = __webpack_public_path__ + "static/img/wuya.92f52d47.gif";